import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { AnimationOnScroll } from "vendors/react-animation-on-scroll";
import GainfulButton from "Root/checkout/components/GainfulButton/index";
import UnderlinedButton from "Root/profile/components/common/UnderlinedButton";
import toastService from "Root/profile/toastService";
import ProductDetailsDrawerV2 from "Root/profile/components/SubscriptionPageV2/ProductDetailsDrawerV2";
import useEditYourBox from "Root/profile/components/SubscriptionPageV2/EditYourBox/useEditYourBox";
import { useHistory } from "react-router-dom";
import InfoIcon from "Images/quiz/info-icon.svg";
import { apiGetProductData } from "../../../../api/apiProfile";
import { productPics } from "../data/data";
import styles from "./style.module.css";
import { Dialog } from "@mui/material";
import H3Font from "Root/profile/components/common/H3Font";
import RegFont from "Root/profile/components/common/RegFont";
import SmallFont from "Root/profile/components/common/SmallFont";
import Button from "Root/profile/components/common/Button";
const ProductTile = ({ personalized, title, portion, price, descr, warnings, item_type, inCart, loggedIn, hasOrdered, addToCartDirect, moveTo, sectionLink, }) => {
    const [productData, setProductData] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const history = useHistory();
    const { openDrawer, addProductOpenDrawer, isOpen, toggleDrawer, isAddProduct, isMoreDetails, getSelectedCurrentProduct, findCurrentQuantity, onSubmit, } = useEditYourBox();
    const fetchProductData = async (product) => {
        try {
            const data = await apiGetProductData(product);
            setProductData(data);
        }
        catch (e) {
            toastService.errorMessage(e);
        }
    };
    const openDrawerConditionally = (key, moreDetail) => {
        if (inCart) {
            openDrawer(key, moreDetail);
        }
        else {
            addProductOpenDrawer(key, moreDetail);
        }
    };
    useEffect(() => {
        if (loggedIn && item_type) {
            fetchProductData(item_type);
        }
    }, [loggedIn, item_type]);
    const tileTitle = (prod) => prod.toLocaleLowerCase().includes("personalized")
        ? prod.toLocaleLowerCase().replace("personalized ", "")
        : prod.toLocaleLowerCase().replace(" performance boost", "");
    const getBtnLabel = () => {
        // if (warnings && warnings.length > 0) {
        //   return "Update Profile";
        // }
        if (!loggedIn) {
            return "take the quiz";
        }
        if (inCart) {
            return "in your subscription";
        }
        return "add to subscription";
    };
    const openQuiz = () => {
        history.push("/quiz");
        window.location.reload();
    };
    const getBtnAction = () => {
        if (warnings && warnings.length) {
            setOpenModal(true);
        }
        else if (hasOrdered) {
            openDrawerConditionally(productData.short_name);
        }
        else if (addToCartDirect) {
            addToCartDirect(productData.short_name);
        }
    };
    const disableBtn = () => {
        if (inCart && warnings && warnings.length > 0) {
            return true;
        }
        if (inCart) {
            return true;
        }
        return false;
    };
    const onClose = () => {
        setOpenModal(false);
    };
    const confirmAndAdd = () => {
        onClose();
        openDrawerConditionally(productData.short_name);
    };
    return (_jsxs("div", { style: personalized
            ? { backgroundColor: "#faf9f5" }
            : { backgroundColor: "#f6f3eb" }, className: styles.tile_container, children: [_jsxs(Dialog, { classes: {
                    paper: styles.modal_root,
                }, open: openModal, onClose: onClose, children: [_jsxs("div", { className: styles.content, children: [_jsxs(H3Font, { fontWeight: 400, children: ["Why we don't recommend ", productData.product_title] }), _jsx("div", { className: styles.warning, children: warnings &&
                                    (Array.isArray(warnings) && warnings.length > 0 ? (warnings.map((warning) => (_jsx(RegFont, { children: warning }, warning.toString())))) : (_jsx(RegFont, { children: warnings }))) }), !inCart && (_jsx(Button, { onClick: confirmAndAdd, variant: "primary", children: "acknowledge and add" }))] }), _jsx("button", { onClick: onClose, className: styles.x_mark, children: _jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("line", { x1: "1.20711", y1: "1.29289", x2: "15.2071", y2: "15.2929", stroke: "#333333", strokeWidth: "2" }), _jsx("line", { x1: "0.792893", y1: "15.2929", x2: "14.7929", y2: "1.29289", stroke: "#333333", strokeWidth: "2" })] }) })] }), _jsxs(AnimationOnScroll, { className: styles.tile_img_container, animateIn: "animate__fadeIn", animateOnce: true, duration: 0.7, children: [_jsx("img", { className: styles.tile_img, src: item_type && productPics[item_type], alt: "product" }), warnings && warnings.length > 0 && (_jsxs("div", { className: styles.not_recommended_label, children: [_jsx(SmallFont, { children: "NOT RECOMMENDED" }), " ", _jsx("div", { onClick: () => setOpenModal(true), children: _jsx("img", { src: InfoIcon, alt: "info" }) })] }))] }), _jsx("p", { className: styles.tile_type, children: item_type === "greens"
                    ? ""
                    : personalized
                        ? "PERSONALIZED"
                        : "PERFORMANCE BOOST" }), _jsx("p", { className: styles.tile_product_title, children: title && tileTitle(title) }), _jsx("p", { className: styles.tile_product_price, children: `${portion} Servings | ${loggedIn && title.toLowerCase().includes("protein")
                    ? "Starting at "
                    : ""}${price}` }), _jsx("div", { children: descr &&
                    descr.length > 0 &&
                    descr.map((desc, i) => (_jsxs(AnimationOnScroll, { animateIn: "animate__fadeIn", animateOnce: true, duration: 0.7, className: styles.tile_descr_line, children: [_jsx("img", { src: desc.icon, className: styles.tile_descr_icon, alt: "icon" }), _jsx("div", { className: styles.tile_descr_text, children: desc.desc })] }, desc.desc || desc.icon + i))) }), loggedIn ? (_jsxs("div", { className: styles.tile_btns_container, children: [hasOrdered && (_jsx(UnderlinedButton, { onClick: () => openDrawerConditionally(productData.short_name, true), extraClassName: "up-product-uderlined-tile-btn", label: "MORE DETAILS", dataAttr: "more-details-button" })), _jsx(GainfulButton, { onClick: () => getBtnAction(), extraClassName: "upProductGainfulTile", text: getBtnLabel(), disabled: disableBtn(), dataAttr: "add-to-subscription-button" })] })) : (_jsx("div", { className: styles.tile_btns_container, children: _jsx(GainfulButton, { onClick: openQuiz, extraClassName: "upProductGainfulTile", text: getBtnLabel(), disabled: disableBtn(), dataAttr: "add-to-subscription-button" }) })), loggedIn && hasOrdered && (
            // @ts-ignore
            _jsx(ProductDetailsDrawerV2, { openDrawer: isOpen, toggleDrawer: toggleDrawer, product: productData.short_name, extraClassName: styles.more_details_wrapper, isMissingItem: isAddProduct, isMoreDetails: isMoreDetails, extraDetailsClassName: "true", ...productData, ...(getSelectedCurrentProduct(productData.short_name) || {}), quantity: findCurrentQuantity(productData.short_name) || 1, onSubmit: onSubmit, moveTo: moveTo && moveTo, source: "PLP" }))] }));
};
export default ProductTile;
